<template>
    <div>
        <v-row no-gutters class="pa-1">
            <v-text-field clearable hide-details single-line outlined dense
                          color="primary"
                          v-model="questionFilterValue"
                          label="Search Questions"
                          append-icon="mdi-search"></v-text-field>
        </v-row>
        <v-list dense>
            <v-list-item-group>
                <v-list-item v-for="(question, q) in getQuestions" :key="q" @click="handleSelectQuestion(question)">
                    <v-list-item-content>
                        <v-list-item-title class="caption">{{question.description}}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-tooltip right>
                            <template v-slot:activator="{on}">
                                <v-btn v-on="on" fab :outlined="getNewQuestion.qid === question.qid" x-small
                                       :color="getNewQuestion.qid === question.qid ? 'primary' : ''" icon ripple>
                                    <v-icon :color="question.linked_id ? 'green' : 'red'">mdi-link</v-icon>
                                </v-btn>
                            </template>
                            <span v-if="question.linked_id">Linked to QuestionMark ({{question.linked_id}})</span>
                            <span v-if="!question.linked_id">Not Linked!</span>
                        </v-tooltip>
                    </v-list-item-action>
                </v-list-item>
            </v-list-item-group>
        </v-list>
    </div>
</template>

<script>

  import {mapGetters, mapMutations} from 'vuex';

  export default {
    name: "QuestionList",

    methods: {
      ...mapMutations(['SET_WORKING_QUESTION', 'SET_QUESTION_FILTER']),
      handleSelectQuestion(q) {
        this.SET_WORKING_QUESTION(q);
        this.$router.push('/details');
      },
    },
    computed: {
      ...mapGetters(['getQuestions', 'getNewQuestion', 'GET_QUESTION_FILTER', 'GET_TASK']),
      questionFilterValue: {
        get() {
          return this.GET_QUESTION_FILTER;
        },
        set(val) {
          this.SET_QUESTION_FILTER(val)
        }
      }
    },

    data() {
      return {}
    }
  }
</script>

<style scoped>

</style>
